import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import fetch from 'isomorphic-fetch'; // https://github.com/apollographql/apollo-link/issues/513#issuecomment-368234260
// import apolloLogger from 'apollo-link-logger';
import { errorLink, authLink, httpLink, retryLink } from './links';

// create apollo cache and setup normalization features with dataIdFromObject
const cache = new InMemoryCache({
  dataIdFromObject: o => o._id,
});

// apolloLogger
let links = [retryLink, errorLink, authLink, httpLink];

// create apollo-client instance
const client = new ApolloClient({
  link: ApolloLink.from(links),
  fetch,
  cache,
  connectToDevTools: true,
});

// export the client to be used by the app
export default client;



// WEBPACK FOOTER //
// ./src/ApolloClient/index.js